export default {
  title: "Contact persons",

  table: {
    noData: "No linked contacts",
  },

  input: {
    title: "{{action}} contact person",
    contact: {
      label: "Contact person",
    },
    type: {
      label: "Relation type",
    },
  },
}
